import Mixpanel from 'common/services/stats/-RFC.Mixpanel';

const _directiveDependencies = [];
const _controllerDependencies = ['$scope', '$rootScope', 'Util'];

class DwmCardController {

    constructor($scope, $rootScope, Util) {

        $scope.turnOnDwm = (variant) => {

            $rootScope.turnOnDwm = true;

            $scope.sendMixpanelEvent(variant);

        };

        const aiaTileAction = Util.deepFind($rootScope.dwmStatus, 'products.identityAssist.tileAction');
        const dwmLiteTileAction = Util.deepFind($rootScope.dwmStatus, 'products.dwmLite.tileAction');

        const dwmLiteSubscriptionStatus = Util.deepFind($rootScope.dwmStatus, 'products.dwmLite.subscriptionStatus');
        const dwmLiteSubscriptionCancelled = dwmLiteSubscriptionStatus === 'cancelled' || dwmLiteSubscriptionStatus === 'none';
        const dwmLiteSubscriptionUpsell = dwmLiteSubscriptionStatus === 'active' && aiaTileAction === 'openUpsell';

        let cardVariant;

        if ($rootScope.showDwmUnreadNotificationsCard) {

            // show aia unread notifications card
            $scope.showAIAUnreadNotificationscard = true;
            $scope.notifications = $rootScope.dwmCardUnreadNotifications;
            cardVariant = 'AIA - Unread notifications';

        } else if ($rootScope.showDwmAddMoreDataCard) {

            // show aia add more data card
            $scope.showAIAAddMoreDatacard = true;
            cardVariant = 'AIA - Add more data';

        } else if (aiaTileAction === 'openDashboard') {

            // show aia dashboard
            $scope.showAIAcard = true;
            cardVariant = 'AIA - Disabled';

        } else if (dwmLiteTileAction === 'openDashboard' && dwmLiteSubscriptionCancelled) {

            // show dwm lite dashboard
            $scope.showDWMLitecard = true;
            cardVariant = 'DWM Lite - Disabled';

        } else if (dwmLiteTileAction === 'openDashboard' && dwmLiteSubscriptionUpsell) {

            // show dwm lite upsell
            $scope.showDWMLiteUpsellcard = true;
            cardVariant = 'DWM Lite - Get full version';

        }

        Mixpanel.send('ConnectWeb Home Widget Show', {
            Label: cardVariant,
        });

        $scope.sendMixpanelEvent = (variant) => {

            let buttonLabel;

            if (variant === 'DWM Lite' || variant === 'AIA') {

                buttonLabel = `Turn ON - ${variant}`;

            } else if (variant === 'DWM Lite Upsell') {

                buttonLabel = 'See more - AIA - Get full version';

            } else if (variant === 'AIA Add more data') {

                buttonLabel = 'Add more data - AIA';

            } else if (variant === 'AIA Unread Notifications') {

                buttonLabel = 'Unread notification - AIA';

            }

            Mixpanel.send('ConnectWeb Home Click', {
                'Button label': buttonLabel,
            });

        };

        $scope.setScrollToNotifications = () => {

            $rootScope.scrollToNotifications = true;

        };

    }

}


class DwmCardDirective {

    constructor() {

        this.template = require('./dwm-card.html');
        this.restrict = 'EA';
        this.replace = true;

        _controllerDependencies.push(($scope, $rootScope, Util) =>
            new DwmCardController($scope, $rootScope, Util));
        this.controller = _controllerDependencies;
        this.controllerAs = 'DwmCardCtrl';

    }

}

_directiveDependencies.push(() => new DwmCardDirective());


angular.module('directives')
    .directive('dwmCard', _directiveDependencies);



// WEBPACK FOOTER //
// ./scripts/directives/dashboard/dwm-card/dwm-card.js